var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tree-graph" }, [
    _c(
      "div",
      { attrs: { id: "canvas" } },
      [
        _c("div", { ref: "thead", staticClass: "thead" }, [
          _vm.parentRoute
            ? _c(
                "div",
                {
                  staticClass: "aside-left",
                  on: {
                    click: function($event) {
                      return _vm.updateRoute(_vm.parentRoute)
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(_vm.parentBtnText) + "\n      ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "aside-center" }, [
            _vm._v("\n        " + _vm._s(_vm.workflowName) + "\n      ")
          ]),
          _vm._v(" "),
          _vm.hasChildBtn
            ? _c(
                "div",
                {
                  staticClass: "aside-right",
                  on: {
                    click: function($event) {
                      return _vm.updateRoute(_vm.childRoute)
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(_vm.childBtnText) + "\n      ")]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.isGraphLoading ? _c("div", { attrs: { id: "loading" } }) : _vm._e(),
        _vm._v(" "),
        !_vm.hasAllEvents
          ? _c(
              "div",
              {
                staticClass: "refresh",
                on: {
                  click: function($event) {
                    return _vm.reloadWorkflow()
                  }
                }
              },
              [_vm._v("\n      Refresh\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("GraphLegend"),
        _vm._v(" "),
        !_vm.isGraphLoading
          ? _c("Graph", {
              key: _vm.forceRefresh,
              attrs: {
                events: _vm.events,
                "selected-event-id": _vm.selectedEventId
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c75d88c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c75d88c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/containers/workflow-history/components/workflow-graph/index.vue
// module id = 1660
// module chunks = 0